<template>
    <div class="reserve">
        <z-title title="预定提成" ref="title"></z-title>
        <!--搜索-->
        <el-card class="content1" ref="search">
          <div class="flex-n fac">
              <el-input
                      size="medium"
                      class="ele-input mr-10"
                      placeholder="输入姓名"
                      maxlength="8"
                      clearable
                      title="输入要搜索的姓名"
                      prefix-icon="el-icon-search"
                      v-model="customName">
              </el-input>
              <el-input
                      size="medium"
                      class="ele-input mr-10"
                      type="number"
                      clearable
                      placeholder="输入电话号码"
                      title="输入电话号码"
                      prefix-icon="el-icon-search"
                      maxlength="11"
                      v-model="phone">
              </el-input>

              <div class="textnowrap">场地：</div>
              <want-house clearable class="mr-10" size="medium" v-model="houseId" placeholder="请选择"></want-house>
              <div class="textnowrap">套餐类型：</div>
              <package-order  clearable class="mr-10" size="medium" v-model="packageId" placeholder="请选择"></package-order>
          </div>
            <div class="flex-n fac mt-10">
                <div class="textnowrap">预定日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="dateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
                <div class="textnowrap">下单日期：</div>
                <el-date-picker
                        size="medium"
                        class="mr-10 date"
                        v-model="orderDateRange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                >
                </el-date-picker>
                <el-button type="primary" class="ele-btn2" @click="searchOrderFinance">查询</el-button>

            </div>
        </el-card>
        <!--列表-->
        <el-card class="mt-10">
            <el-table
                    v-loading="loading"
                    :height="height+'px'"
                    highlight-current-row
                    element-loading-text="列表刷新中"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="dataList"
                    style="width: 100%">
                <el-table-column
                        fixed
                        align="center"
                        prop="customName"
                        label="客户姓名"
                        min-width="120">
                </el-table-column>
                <!--<el-table-column-->
                        <!--label="订单状态"-->
                        <!--min-width="100"-->
                        <!--align="center">-->
                    <!--<template slot-scope="scope">-->
                        <!--<el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='04'" type="warning">-->
                            <!--{{scope.row.confirmStateText}}-->
                        <!--</el-tag>-->
                        <!--<el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='03'" type="info">-->
                            <!--{{scope.row.confirmStateText}}-->
                        <!--</el-tag>-->
                        <!--<el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='02'" type="danger">-->
                            <!--{{scope.row.confirmStateText}}-->
                        <!--</el-tag>-->
                        <!--<el-tag size="mini" effect="plain" v-if="scope.row.confirmState=='01'" type="success">-->
                            <!--{{scope.row.confirmStateText}}-->
                        <!--</el-tag>-->

                    <!--</template>-->
                <!--</el-table-column>-->

                <el-table-column
                        prop="phone"
                        label="电话"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="预定日期"
                        width="190"
                        align="center">
                    <template  slot-scope="scope">
                        {{scope.row.orderDate}} {{scope.row.activityBeginTime}}~{{scope.row.activityEndTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="houseName"
                        label="预定场地"
                        min-width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                    prop="orderNumber"
                    label="预定桌数"
                    min-width="180"
                    align="center">
            </el-table-column>
                <el-table-column
                        prop="commissionMoney"
                        label="提成金额"
                        min-width="180"
                        align="center">
                </el-table-column>

                <el-table-column
                        prop="packageName"
                        label="预定套餐"
                        min-width="160"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserName"
                        label="接待人员"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="createUserPhone"
                        label="接待电话"
                        width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="downPayment"
                        label="定 金"
                        min-width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                        label="应收款"
                        min-width="150"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.orderNeedMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="实收款"
                        min-width="150"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.realPayment||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="退款金额"
                        min-width="150"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.refundMoney||0}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="差额"
                        min-width="150"
                        align="center">
                    <template slot-scope="scope">
                        {{(scope.row.realPayment||0)-(scope.row.orderNeedMoney||0)-(scope.row.refundMoney||0)}}
                    </template>
                </el-table-column>


                <el-table-column
                        fixed="right"
                        label="操作"
                        width="170"
                        align='center'
                >
                    <template slot-scope="scope">
                        <div style="padding: 5px 0" >
                            <el-button class="ele-btn-small"  type="primary" size="mini" @click="getDetail(scope.row.id)"
                            >查看明细
                            </el-button><el-button class="ele-btn-small" v-if="scope.row.hasCommission==0"  type="primary" size="mini" @click="gotoCommission(scope.row.id)"
                        >提成
                        </el-button>
                            <el-popconfirm
                                    title="是否确定修改提成?"
                                    @confirm="gotoCommission(scope.row.id)"
                                    v-else

                            >
                                <el-button class="ele-btn-small ml-10"  type="primary" size="mini"  slot="reference">修改提成</el-button>
                            </el-popconfirm>

                        </div>

                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
      <res-commission :visible.sync="showCommission" :id="orderId" :state="editstate" @refreshList="getOrderFinance"></res-commission>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import PackageTypes from "../../components/data/packageTypes";
    import WantHouse from "../../components/data/wantHouse";
    import OrderConfirmState from "../../components/data/orderConfirmState";
    import PackageOrder from "../../components/data/packageOrder";
    import Pagination from "../../components/pagination/pagination";
    import ResCommission from "./sub/ResCommission";



    export default {
        components: {
            ResCommission,
            Pagination,
            PackageOrder,
            OrderConfirmState,
            WantHouse,
            PackageTypes,
            ZTitle
        },
        name: "reserve",
        data() {

            return {
                loading: false,
                loading2: false,
                pageSize: 20,
                currentPage: 1,
                total: 0,
                height: 250,
                showedit: false,

                dataList: [],

                customName: '',
                phone: '',
                dateRange: [],
                orderDateRange:[],
                houseId: '',
                packageId: '',
                confirmState: '',
                id: '',
                orderId: '',


                showCommission:false,//结算弹窗
                editstate:0,

            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            var date=this.$TM.getDayArea();
            var mm=date.mm,yy=date.yy;
            if(mm==12){
                mm=1;
                yy++;
            }
            var date2=new Date(new Date(this.$TM.getDayArea(yy,mm+1,1).date).getTime()-24*60*60*1000);            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.dateRange=[date.yy+'-'+date.mm+'-1',date2.getFullYear()+'-'+(date2.getMonth()+1)+'-'+date2.getDate()];
            this.getOrderFinance();
        },
        computed: {
            pickerOptions() {
                var that=this;
                return{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '昨日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num-1));
                                end.setTime(end.getTime() + 3600 * 1000 * 24 * (7-num));
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                var num=start.getDay();
                                if(num==0){
                                    num=7;
                                }
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (num+6));
                                end.setTime(end.getTime() - 3600 * 1000 * 24 * num);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                const start = new Date();
                                var year=start.getFullYear(),month=start.getMonth()+1;
                                var startDate=new Date(year+'-'+month+'-1');
                                var length=that.$TM.getMonthArea().length-1;
                                var dd=that.$TM.getMonthArea()[length].dd;
                                var endDate= new Date(that.$TM.getMonthArea()[length-(dd<7?dd:0)].date);
                                console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                const start = new Date();
                                console.log(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}))
                                var month=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].mm,
                                    year=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[15].yy;
                                var length=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1}).length-1;
                                var dd=that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length].dd;
                                var startDate=new Date(year+'-'+month+'-1');
                                var endDate= new Date(that.$TM.beforeMouth({yy:start.getFullYear(),mm:start.getMonth()+1,dd:1})[length-(dd<7?dd:0)].date);
                                // console.log(startDate,endDate)
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                }
            }
        },

        methods: {
            //预定结算列表查询
            getOrderFinance() {
                this.loading = true;
                console.log(this.dateRange)
                this.$axios.post('/order/orderList', {
                    "storeId": this.$root.getStorage('storeId'),
                    "currentPage": this.currentPage,
                    "pageSize": this.pageSize,
                    "customName": this.customName,
                    "phone": this.phone,
                    "startTime": this.dateRange ? this.dateRange[0] : '',
                    "endTime": this.dateRange ? this.dateRange[1] : '',
                    "createTimeBegin": this.orderDateRange?this.orderDateRange[0]:'',
                    "createTimeEnd": this.orderDateRange?this.orderDateRange[1]:'',
                    "houseId": this.houseId,
                    "packageId": this.packageId,
                    "confirmState": '01',
                }).then(res => {
                    console.log('预定数据列表', res);
                    var dataList = res.data.list;
                    for (var i in dataList) {
                        // dataList[i].difference = (dataList[i].orderMoney - dataList[i].realPayment).toFixed(2)
                        var content = '';
                        for (var j in  dataList[i].payTypes) {
                            if (dataList[i].payTypes[j].payTypeCode == '01') {
                                content += (dataList[i].payTypes[j].orderCount || 0) + '人、';
                            }
                            if (dataList[i].payTypes[j].payTypeCode == '02') {
                                content += (dataList[i].payTypes[j].orderCount || 0) + '桌、';
                            }
                        }

                        if (content.substring(content.length - 1, content.length) == '、') {
                            content = content.substring(0, content.length - 1)
                        }
                        if (content != '') {
                            if (dataList[i].mainPayType == '03') {
                                dataList[i].orderNumber = '包场(' + content + ')'
                            } else {
                                dataList[i].orderNumber = content
                            }

                        }
                    }

                    this.dataList = dataList;
                    this.total = res.data.total;
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            //搜索
            searchOrderFinance() {
                this.currentPage = 1;
                this.getOrderFinance();

            },
            //获取明细
            getDetail(orderId){
                this.orderId=orderId;
                this.editstate=1;
                this.showCommission=true;
            },
            //显示提成
            gotoCommission(orderId) {
                this.showCommission=true;
                this.editstate=0;
                this.orderId = orderId;
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.getOrderFinance();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getOrderFinance();
                console.log(`当前页: ${val}`);
            },

        },
    }
</script>

<style scoped lang="scss">
    .member_bg {
        margin: 0 80px;
        box-shadow: none;
        background: #fefefe;
    }

    .el-divider__text {
        font-weight: 700 !important;
        color: #5295e7;
    }

    .reserve {
        .content1 {
            .textnowrap {
                font-size: 13px;
                color: #333;
            }
            .date {
                min-width: 100px;
            }
        }
    }
</style>